import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.LOCATION_AND_PREMISES}` as const;

export const PREMISES_INFORMATION_NAMES = {
  FILE: 'file',
  ADDRESS: 'address',
  AREA: 'area',
  TERMS_OF_USE: 'termsOfUse',
  CURRENT_COST: 'currentCost',
  PURPOSE: 'purpose',
} as const;

export interface IPremisesInformation {
  [PREMISES_INFORMATION_NAMES.FILE]: IImageFile[];
  [PREMISES_INFORMATION_NAMES.ADDRESS]: string;
  [PREMISES_INFORMATION_NAMES.AREA]: string;
  [PREMISES_INFORMATION_NAMES.TERMS_OF_USE]: string;
  [PREMISES_INFORMATION_NAMES.CURRENT_COST]: string;
  [PREMISES_INFORMATION_NAMES.PURPOSE]: string;
}

export const premisesInformationValue = {
  [PREMISES_INFORMATION_NAMES.FILE]: [],
  [PREMISES_INFORMATION_NAMES.ADDRESS]: '',
  [PREMISES_INFORMATION_NAMES.AREA]: '',
  [PREMISES_INFORMATION_NAMES.TERMS_OF_USE]: '',
  [PREMISES_INFORMATION_NAMES.CURRENT_COST]: '',
  [PREMISES_INFORMATION_NAMES.PURPOSE]: '',
};

export const LOCATION_AND_PREMISES_NAMES = {
  LOCATION: 'location',
  PREMISES_INFORMATION: 'premisesInformation',
  QUALITIES: 'qualities',
  FUTURE_PLANS: 'futurePlans',
} as const;

export interface ILocationsAndPremises {
  [LOCATION_AND_PREMISES_NAMES.LOCATION]: string;
  [LOCATION_AND_PREMISES_NAMES.PREMISES_INFORMATION]: IPremisesInformation[];
  [LOCATION_AND_PREMISES_NAMES.QUALITIES]: string;
  [LOCATION_AND_PREMISES_NAMES.FUTURE_PLANS]: string;
}

export const locationsAndPremisesInitialValue = {
  [LOCATION_AND_PREMISES_NAMES.LOCATION]: '',
  [LOCATION_AND_PREMISES_NAMES.PREMISES_INFORMATION]: [premisesInformationValue],
  [LOCATION_AND_PREMISES_NAMES.QUALITIES]: '',
  [LOCATION_AND_PREMISES_NAMES.FUTURE_PLANS]: '',
};

